import { Component, OnInit, Input, ViewChild,EventEmitter, AfterViewInit, OnChanges, SimpleChange, Output } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/modal';




@Component({
  selector: 'modalcomponent',
  templateUrl: './modalcomponent.component.html',
  styleUrls: ['./modalcomponent.component.css']
})
export class ModalcomponentComponent implements OnInit, AfterViewInit, OnChanges  {

  @Input() _mostrarmodal: any;
  @Input() _mensaje: any;
  @ViewChild('staticModalRespuestas') public staticModalRespuestas:ModalDirective;

  @Output() onChangeModal = new EventEmitter<any>();

  mostrarmodal: boolean = false;
  mensaje = '';

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_mostrarmodal']){
      this.mostrarmodal = changes['_mostrarmodal'].currentValue;
    }

    if (changes['_mensaje']){
      this.mensaje = changes['_mensaje'].currentValue;
    }

  }

  ngAfterViewInit(){
    this.abrirModal();
  }

  abrirModal(){
    if (this.mostrarmodal){
      this.staticModalRespuestas.show();
    }
  }

  cerrarModal(value: any){

    this.staticModalRespuestas.hide();
    this.onChangeModal.emit(value);
  
  }


}



// WEBPACK FOOTER //
// ./src/app/modalcomponent/modalcomponent.component.ts